import { createBrowserRouter, Navigate, Outlet, RouterProvider } from 'react-router-dom';
import { Discover } from './routes/Discover';
import { Prayer } from './routes/Prayer';
import { Cards } from './routes/Cards';
import { Saved } from './routes/Saved';
import { TabBar } from './components/TabBar';
import { I18nProvider, useT } from './i18n';

/**
 * A real router, which v2 had none of.
 *
 * Consequences of that gap: no shareable link to a place, a back button that
 * exited the app, and a Share feature producing URLs that resolved to nothing.
 * Every screen now has an address, and /city/:id/place/:placeId opens a specific
 * venue directly.
 */
function Shell() {
    const { t } = useT();
    return (
        <>
            <a className="skip-link" href="#main">{t('nav.skip')}</a>
            <main id="main"><Outlet /></main>
            <TabBar />
        </>
    );
}

const router = createBrowserRouter([
    {
        element: <Shell />,
        children: [
            { path: '/', element: <Navigate to="/city/hongkong" replace /> },
            { path: '/city/:cityId', element: <Discover /> },
            { path: '/city/:cityId/place/:placeId', element: <Discover /> },
            { path: '/city/:cityId/prayer', element: <Prayer /> },
            // Old link shape, kept so shared /qibla URLs still resolve.
            { path: '/city/:cityId/qibla', element: <Prayer /> },
            { path: '/city/:cityId/cards', element: <Cards /> },
            { path: '/saved', element: <Saved /> },
            { path: '*', element: <Navigate to="/city/hongkong" replace /> },
        ],
    },
]);

export function App() {
    return (
        <I18nProvider>
            <RouterProvider router={router} />
        </I18nProvider>
    );
}
